import clsx from "clsx";
import { LabelMetadata } from "../constants/labeling.constants";
import { LabelItem } from "./LabelItem";
import { AccountLabel } from "@/entities/DataAssociation/Account.model";

export function LabelList({
    labels,
    selectedLabel,
    onLabelSelection,
    recommendedLabels = [],
}: {
    labels: LabelMetadata[];
    recommendedLabels?: AccountLabel[];
    selectedLabel?: AccountLabel | null;
    onLabelSelection: (label: AccountLabel) => void;
}) {
    return (
        <ul
            className={clsx(
                "pb-4",
                "hide-scrollbar flex flex-1 flex-col gap-1 overflow-y-auto",
            )}
            role="list"
        >
            {labels?.map((item) => (
                <LabelItem
                    key={item.code}
                    listItem
                    label={item}
                    className={clsx(selectedLabel === item.code && "selected")}
                    onClick={() => {
                        onLabelSelection(item.code);
                    }}
                    recommended={recommendedLabels.includes(item.code)}
                />
            ))}
        </ul>
    );
}
